'use client';
import { ScrollArea } from '../../components/scroll-area';

import { cn } from '@bells/core/lib/utils';
import { attendantsFilterTitle, resetFilter } from '@bells/i18n';
import { Button } from '../../components/button';
import { useFilter } from './filter-provider';

import Filter from './filter';
import { useMediaQuery } from '../../hooks/use-media-query';

export const AttendantSidebar = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  const { totalFilters, reset } = useFilter();

  if (!isDesktop) {
    return null;
  }
  return (
    <aside
      className={cn('sticky top-[58px] h-[calc(100vh-58px)] w-full border-r')}
    >
      <ScrollArea className='h-full w-full'>
        <div className='3xl:pr-8 space-y-2 py-4 lg:py-8 lg:pr-4'>
          <div className='mb-4 text-sm font-medium uppercase text-muted-foreground'>
            {attendantsFilterTitle()}
          </div>

          <Filter></Filter>
          <Button
            className='w-full'
            onClick={() => {
              reset();
            }}
            disabled={totalFilters <= 0}
            variant={totalFilters > 0 ? 'default' : 'outline'}
          >
            {resetFilter()}
            {totalFilters > 0 && <span>({totalFilters})</span>}
          </Button>
        </div>
      </ScrollArea>
    </aside>
  );
};
